<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/homePage' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>经理管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.company_id" placeholder="公司名称" clearable @change="searchChange"
							@clear="clearInput" style="width: 100%" size="small">
							<el-option v-for="item in companysList" :key="item.id" :label="item.title"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.realname" autocomplete="off" maxlength="30" placeholder="员工名称"
							clearable size="small" @change="searchChange" @clear="clearInput2" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.mobile" autocomplete="off" maxlength="30" placeholder="电话号码"
							clearable size="small" @change="searchChange" @clear="clearInput3" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange"
							size="small">搜索</el-button>
						<el-button icon="el-icon-plus" type="success" @click="handleNewAdd"
							size="small">新增经理</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- 分割线 -->
		<el-table :data="tableLists" style="width: 100%; margin-top: 2vh" border size="mini" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }">
			<el-table-column prop="id" label="id" align="center" />
			<el-table-column prop="realname" label="姓名" align="center" />
			<el-table-column prop="mobile" label="手机号码" align="center" />
			<el-table-column prop="title" label="经理头像" align="center">
				<template slot-scope="scope">
					<el-image :src="scope.row.headimg" :preview-src-list="[scope.row.headimg]"
						style="width: 80px; height: 80px"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="mobile" label="所属公司" align="center">
				<template slot-scope="scope">
					{{ findCompanyById(scope.row.company_id) }}
				</template>
			</el-table-column>
			<el-table-column prop="type" label="角色" align="center">
				<template slot-scope="scope">
					{{ scope.row.type == '2' ? '经理' : (scope.row.type == '4' ? '内勤' : '') }}
				</template>
			</el-table-column>
			<el-table-column prop="exp_time" label="到期时间" align="center" />
			<el-table-column prop="created_at" label="创建时间" align="center" />
			<el-table-column prop="status" label="人员状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="280">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="60%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" style="margin-top: -10vh"
			:lock-scroll="false" :append-to-body="true">
			<el-form ref="form" :model="form" label-width="120px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="经理名称" required>
							<el-input v-model="form.realname" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="手机号码" required>
							<el-input v-model="form.mobile" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<!-- <el-form-item label="密码" required>
							<el-input v-model="form.password" autocomplete="off" placeholder="请输入" />
						</el-form-item> -->
						<el-form-item label="到期时间">
							<el-date-picker v-model="form.exp_time" value-format="yyyy-MM-dd"
								type="date" placeholder="选择日期" style="width: 100%" @input="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="导表权限">
						<el-switch v-model="form.can_export" :active-value="1" :inactive-value="0"
							@change="changeStatus(scope.row)"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="所属公司" required>
							<el-select v-model="form.company_id" placeholder="请选择" clearable filterable
								style="width: 100%">
								<el-option v-for="item in companysList" :key="item.id" :label="item.title"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="角色选择">
							<el-select v-model="form.type" placeholder="请选择" clearable filterable
								style="width: 100%">
								<el-option v-for="item in roles" :key="item.id" :label="item.name"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="备注信息" required>
							<el-input v-model="form.remark" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="经理头像" required>
							<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="headers"
								:disabled="true">
								<div class="avatar-wrapper">
									<el-image :preview-src-list="[imageUrl]" v-if="imageUrl" :src="imageUrl"
										class="avatar" />
									<i v-if="imageUrl" class="el-icon-close" @click.stop="removePic"></i>
									<i v-else class="el-icon-picture-outline avatar-uploader-icon"
										@click="uploadPicIcon"></i>
								</div>
							</el-upload>
							<div style="color: #999; margin-top: 0vh">
								图片大小建议800*800
							</div>
							<div class="chooseImg">
								<el-button type="info" @click="chooseImg()">选择图片</el-button>
								<el-input v-model="imageUrl" autocomplete="off" placeholder="请输入图片地址" />
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-col :span="24">
					<el-form ref="queryForm" :model="searchFormS" inline label-width="128px">
						<el-form-item style="margin-bottom: 0" label="小区操作:">
							<el-input v-model="searchFormS.title" autocomplete="off" maxlength="30" placeholder="搜索小区"
								@change="searchChangeS" @focus="clickSearch" size="small" />
						</el-form-item>
						<el-form-item style="margin-bottom: 0">
							<el-select v-model="searchFormS.city_id" placeholder="请选择城市" size="small"
								@change="searchChangeC" @visible-change="clickSearch">
								<el-option v-for="item in cityList" :key="item.id" :label="item.title"
									:value="item.id" />
							</el-select>
						</el-form-item>
						<el-form-item style="margin-bottom: 0">
							<el-select v-model="searchFormS.company_id" placeholder="请选择公司" size="small"
								@change="changeCompany" @visible-change="clickSearch">
								<el-option v-for="item in companysList" :key="item.id" :label="item.title"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-form>
					<el-form-item label="选择小区权限:">
						<el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false"
							style="margin-top: 1vh" :props="defaultProps">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<el-row>
									<el-col :span="24">
										<span v-if="data.id !== 8169">
											<el-checkbox-button :true-label="right" :false-label="error"
												v-model="data.ifget" size="mini"
												@change="getfirst(data)">{{ node.label }}</el-checkbox-button>
											<el-checkbox-button :true-label="right" :false-label="error"
												v-model="data.qiye" size="mini"
												@change="qiyeClick(data)">企</el-checkbox-button>
											<el-checkbox :true-label="right" class="custom-size" :false-label="error"
												v-model="data.noget" @change="getall(data)"></el-checkbox>
										</span>
									</el-col>
								</el-row>
							</span>
						</el-tree>
					</el-form-item>
				</el-col>
			</el-form>

			<el-dialog title="企业微信链接" :visible.sync="qiyeShow" :close-on-click-modal="false" width="30%"
				class="dialogHeight global-dialog-position" :before-close="qiyeClose" append-to-body>
				<el-input v-model="qiye" autocomplete="off" clearable size="small" placeholder="请输入企业微信链接"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="qiyeSubmit">保 存</el-button>
					<el-button @click="qiyeClose">取 消</el-button>
				</span>
			</el-dialog>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="85%"
			class="dialogHeight global-dialog-position" style="margin-top: -7vh">
			<imgUpload ref="imgUpload" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFormz">确 定</el-button>
			</div>
			<div slot="body" style="height: 50vh"></div>
		</el-dialog>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
	</div>
</template>

<script>
	import {
		getpersonList,
		addPerson,
		editPerson,
		deletePerson,
	} from "../../api/identity";
	import {
		getcommunityList
	} from "../../api/community";
	import {
		getCookie
	} from "../../utils/util";
	import {
		getCompanysList
	} from "../../api/userMG";
	import imgUpload from "../../components/uploadImg.vue";
	import {
		getCityeList
	} from "../../api/city";
	export default {
		components: {
			imgUpload,
		},
		data() {
			return {
				upImg: false,
				qiyeShow: false,
				qiye: '',
				currentXiaoqu: null,
				companysList: [],
				form: {
					type: 2,
					password: "",
				},
				searchFormS: {},
				addOrEditOpen: false,
				roles: [{id:'2', name:'经理'},{id:'4', name:'内勤'}],
				title: "",
				checked: "",
				dataForm: [],
				right: "right",
				error: "error",
				data: [],
				value: [],
				texts: "曾阿",
				beijing: "背景",
				tableList: [],
				total: 0,
				searchForm: {
					page: 1,
					pageSize: 15,
					type: 2,
				},
				// 判断添加还是修改
				actionType: "",
				// 筛选出的数组
				tableLists: [],
				defaultProps: {
					children: "children",
					label: "label",
				},
				imageUrl: "",
				imageUrls: "",
				// 上传头文件
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				// 图片上传地址
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				imgFirst: false,
				imgSecond: false,
				upImg: false,
				cityTitle: "",
				company_id: "",
				// 搜索信息
				searchCityForm: {},
				// 所在城市
				cityList: "",
				// 城市id
				city_id: "",
				// 切换后全部数组
				mergedArray: [],
				// 修改数组id
				arrId: "",
			};
		},
		watch: {
			upImg(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.imgUpload.resetSelect();
					});
				}
			},
		},
		mounted() {
			this.initList();
			// this.getcommunityLists();
			this.getCompanysLists();
			this.getCityeLists();
		},
		methods: {
			changeDate() {
				this.$forceUpdate()
			},
			uploadPicIcon() {
				this.$message.warning("请点击下方选择图片按钮进行上传");
			},
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				editPerson(this.form).then((msg) => {
					if (msg.code !== 200) return this.$message("状态修改失败");
				});
			},
			// 城市下拉
			getCityeLists() {
				const form = {
					select: 1,
				};
				getCityeList(form).then((res) => {
					this.cityList = res.data.records;
				});
			},
			async changeCompany(res) {
				this.company_id = res;
				if (!this.searchFormS.city_id) {
					delete this.searchFormS.city_id;
				}
				await this.getcommunityLists(this.company_id);

				for (var i = 0; i < this.searchCityForm.length; i++) {
					for (var j = 0; j < this.data.length; j++) {
						if (this.searchCityForm[i].xiaoqu_id == this.data[j].id) {
							this.data[j].ifget = "right";
							if (this.searchCityForm[i].status === 0) {
								this.data[j].noget = "error";
							} else {
								this.data[j].noget = "right";
							}
						}
					}
				}
			},
			submitFormz() {
				if (this.$refs.imgUpload.faData.url) {
					if (this.imgFirst && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();
						this.imageUrl = this.$refs.imgUpload.faData.url;
						this.form.headimg = this.imageUrl;
					} else if (
						this.imgSecond &&
						this.$refs.imgUpload.faData.url !== undefined
					) {
						this.$refs.imgUpload.findTrue();
						this.imageUrls = this.$refs.imgUpload.faData.url;
						this.form.qr_img = this.imageUrls;
					}
					this.$refs.imgUpload.faData.url = "";
					this.$refs.imgUpload.getimgLists();
					this.upImg = false;
				} else {
					this.$message.warning("请选择一张照片");
				}
			},
			chooseImg() {
				this.imgSecond = false;
				this.imgFirst = true;
				this.upImg = true;
			},
			chooseImg2() {
				this.imgFirst = false;
				this.imgSecond = true;
				this.upImg = true;
			},
			// 改变状态
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				// this.handleEdit();
				// this.imageUrls = this.form.qr_img;
				// this.imageUrl = this.form.headimg;

				// for (var i = 0; i < this.form.xiaoqu.length; i++) {
				// 	for (var j = 0; j < this.data.length; j++) {
				// 		if (this.form.xiaoqu[i].xiaoqu_id == this.data[j].id) {
				// 			this.data[j].ifget = "right";
				// 			if (this.form.xiaoqu[i].status === 0) {
				// 				this.data[j].noget = "error";
				// 			} else {
				// 				this.data[j].noget = "right";
				// 			}
				// 		}
				// 	}
				// }
				// this.getdata();
				editPerson(this.form).then((msg) => {
					if (msg.code !== 200) {
						return this.$message("获取状态失败");
					} else{
						this.initList();
					}
				});
			},
			// 点击清空事件
			clearInput() {
				this.searchForm.company_id = undefined;
				this.initList();
			},
			clearInput2() {
				this.searchForm.realname = undefined;
				this.initList();
			},
			clearInput3() {
				this.searchForm.mobile = undefined;
				this.initList();
			},
			// 搜索重置
			resets() {
				this.searchForm = {
					title: undefined,
				};
				this.initList();
			},
			// 移除图片
			removePic() {
				this.imageUrl = "";
				this.form.headimg = "";
			},
			// 移除第二张
			removePics() {
				this.imageUrls = "";
				this.form.qr_img = "";
			},
			// 公司下拉
			getCompanysLists() {
				const form = {
					select: 1,
				};
				getCompanysList(form).then((res) => {
					this.companysList = res.data.records;
				});
			},
			// 查找公司
			findCompanyById(company_id) {
				const company = this.companysList.find(
					(company) => company.id === company_id
				);
				return company ? company.title : "未知";
			},
			// 删除人员
			singleDel(res, req) {
				this.$confirm("确定删除吗？", "删除", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(async () => {
					const res = await deletePerson(req);
					if (res.code !== 200) return this.$message.error("删除失败!");
					this.$message.success("删除成功");
					this.initList();
				});
			},
			// 上传二维码
			onhandleAvatarSuccess(res, file) {
				console.log(res);
				this.imageUrls = res.data.path;
				this.form.qr_img = this.imageUrls;
				//   this.form.sales_img = this.imageUrl;
				//   console.log(this.imageUrl);
			},
			beforeAvatarUpload(file) {
				const isJPG =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpeg" ||
					file.type === "image/webp";
				const isLt2M = file.size / 1024 / 1024 < 1000;

				if (!isJPG) {
					this.$message.error("图片格式不对");
				}
				return isJPG;
			},
			// 上传二维码
			handleAvatarSuccess(res, file) {
				console.log(res);
				this.imageUrl = res.data.path;
				this.form.headimg = this.imageUrl;
				//   this.form.sales_img = this.imageUrl;
				//   console.log(this.imageUrl);
			},
			// 新增弹窗
			async handleNewAdd() {
				this.searchFormS = {
					title: undefined,
					city_id: undefined,
				};
				await this.getcommunityLists();
				this.title = "新增";
				this.actionType = "add";
				this.form = {
					type: '2',
					password: "",
					xiaoqu: [],
				};
				this.imageUrl = "";
				this.imageUrls = "";
				this.addOrEditOpen = true;
			},
			// 修改弹窗
			async handleClick(row) {
				this.searchFormS = {
					title: undefined,
					city_id: undefined,
				};
				await this.getcommunityLists();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				this.arrId = this.form.id;
				this.imageUrls = this.form.qr_img;
				this.imageUrl = this.form.headimg;
				if (this.$refs.imgUpload) {
					this.$refs.imgUpload.faData.url = "";
				}

				this.searchCityForm = this.form.xiaoqu;

				for (var i = 0; i < this.form.xiaoqu.length; i++) {
					for (var j = 0; j < this.data.length; j++) {
						if (this.form.xiaoqu[i].xiaoqu_id == this.data[j].id) {
							this.data[j].ifget = "right";
							this.data[j].wx = this.form.xiaoqu[i].staff_business_wx;
							this.data[j].qiye = this.form.xiaoqu[i].staff_business_wx && this.form.xiaoqu[i]
								.staff_business_wx.length ? "right" : "error";
							if (this.form.xiaoqu[i].status === 0) {
								this.data[j].noget = "error";
							} else {
								this.data[j].noget = "right";
							}
						}
					}
				}

				this.actionType = "edit";
				this.addOrEditOpen = true;
			},
			// 选项1点击取消时同时取消选项2
			getfirst(res) {
				if (res.ifget == "error") {
					res.noget = "error";
				} else if (res.ifget == "right") {
					// return;
				}
				this.formFilter(res);
			},
			// 选项2点击确定时同时确定选项2
			getall(res) {
				if (res.noget == "right") {
					res.ifget = "right";
				} else if (res.noget == "error") {
					// return;
				}
				this.formFilter(res);
			},
			// 企业微信输入
			qiyeClick(res) {
				this.qiyeShow = true;
				this.qiye = res.wx;
				this.currentXiaoqu = res;
				res.qiye = res.wx ? "right" : "error";
			},
			qiyeClose() {
				this.qiyeShow = false;
				this.qiye = '';
				this.currentXiaoqu = null;
			},
			qiyeSubmit() {
				if (this.qiye.length) {
					this.currentXiaoqu.wx = this.qiye;
					this.currentXiaoqu.qiye = "right";
				} else {
					this.currentXiaoqu.wx = '';
					this.currentXiaoqu.qiye = "error";
				}
				this.formFilter(this.currentXiaoqu);
				this.qiyeClose();
			},
			// 添加、取消小区权限
			formFilter(res) {
				if (!this.form.xiaoqu) {
					this.form.xiaoqu = [];
				}

				if (res.ifget == "right") {
					var lit = {
						xiaoqu_id: res.id,
						staff_business_wx: res.wx
					};
					if (res.noget == "right") {
						lit.status = 1;
					} else {
						lit.status = 0;
					}

					let index = -1;
					this.form.xiaoqu.map((item, i) => {
						if (item.xiaoqu_id == res.id) {
							index = i;
						}
					});
					if (index == -1) {
						this.form.xiaoqu.push(lit);
					} else {
						this.form.xiaoqu.splice(index, 1, lit)
					}
				} else {
					let index = -1;
					this.form.xiaoqu.map((item, i) => {
						if (item.xiaoqu_id == res.id) {
							index = i;
						}
					});
					this.form.xiaoqu.splice(index, 1)
				}
			},
			// 请求小区数据
			async getcommunityLists(res) {
				const form = {
					select: 1,
					company_id: res,
					title: this.searchFormS.title,
					city_id: this.searchFormS.city_id,
				};

				try {
					const response = await getcommunityList(form);
					const arrsd = [];
					const filterData = response.data.records;

					filterData.filter((res) => {
						const arrs = {
							id: res.id,
							label: res.title,
							wx: '',
							ifget: "error",
							noget: "error",
							qiye: "error"
						};
						arrsd.push(arrs);
					});

					this.data = arrsd;
				} catch (error) {
					// 处理异常情况
				}
			},
			// 重置
			reset() {
				this.form = {
					realname: undefined,
					headimg: undefined,
					mobile: undefined,
					password: undefined,
					remark: undefined,
					status: undefined,
					qr_img: undefined,
					xiaoqu: [],
				};
				(this.imageUrls = undefined), (this.imageUrl = undefined);
			},
			// 弹窗关闭
			getout() {
				this.addOrEditOpen = false;
				this.reset();
				this.$refs.form.clearValidate();
				this.getcommunityLists();
			},
			getdata() {
				const datas = this.data;
				const newtreedata = [];
				datas.map((res) => {
					if (res.ifget == "right") {
						var lit = {
							xiaoqu_id: res.id,
						};
						if (res.noget == "right") {
							lit.status = 1;
						} else {
							lit.status = 0;
						}
						newtreedata.push(lit);
					}
				});
				this.form.xiaoqu = newtreedata;
				delete this.form.created_at;
				delete this.form.gzh_openid;
				delete this.form.mid;
				delete this.form.sort;
				delete this.form.mark_xiaoqu_json;
				delete this.form.xiaoqu_id;
			},
			// 确定
			submitForm() {
				if (this.actionType == "edit") {
					// this.getdata();
					// console.log(this.form);
					// if (this.mergedArray.length > 0) {
					// 	const comArrs = [
					// 		...new Set([
					// 			...this.mergedArray,
					// 			...this.form.xiaoqu.filter(
					// 				(item) =>
					// 				!this.mergedArray.some(
					// 					(elem) => elem.xiaoqu_id === item.xiaoqu_id
					// 				)
					// 			),
					// 		]),
					// 	];
					// 	this.form.xiaoqu = comArrs;
					// }

					if (!this.form.id) {
						this.form.id = this.arrId;
					}
					editPerson(this.form).then((res) => {
						if (res.code !== 200) return this.$message.error("修改失败!");
						this.$message.success("修改成功");
						this.initList();
						this.reset();
						this.getcommunityLists();
						this.addOrEditOpen = false;
						this.$nextTick(() => {
							this.mergedArray = [];
							this.form.xiaoqu = [];
						});
					});
				} else if (this.actionType == "add") {
					// this.getdata();
					this.form.type = '2';
					addPerson(this.form).then((res) => {
						if (res.code !== 200) return this.$message.error("添加失败!");
						this.$message.success("添加成功");
						this.initList();
						this.reset();
						this.getcommunityLists();
						this.addOrEditOpen = false;
					});
				}
			},
			// 搜索
			searchChange() {
				this.searchForm.type = '2,4';
				this.initList();
			},
			async clickSearch() {
				this.getdata();
				if (this.mergedArray && this.mergedArray.length > 0) {
					await this.getdata();
					const comArr = [
						...new Set([
							...this.mergedArray,
							...this.form.xiaoqu.filter(
								(item) =>
								!this.mergedArray.some(
									(elem) => elem.xiaoqu_id === item.xiaoqu_id
								)
							),
						]),
					];
					this.mergedArray = comArr;
					this.form.xiaoqu = this.mergedArray;
					if (!this.form.id) {
						this.form.id = this.arrId;
					}
					// editPerson(this.form).then((res) => {
					// 	console.log(res);
					// });
				} else {
					this.mergedArray = [...this.mergedArray, ...this.form.xiaoqu];
					console.log(this.mergedArray);
				}
			},
			// 根据城市选
			async searchChangeC() {
				if (!this.searchFormS.city_id) {
					delete this.searchFormS.city_id;
				}
				await this.getcommunityLists(this.company_id);

				for (var i = 0; i < this.searchCityForm.length; i++) {
					for (var j = 0; j < this.data.length; j++) {
						if (this.searchCityForm[i].xiaoqu_id == this.data[j].id) {
							this.data[j].ifget = "right";
							if (this.searchCityForm[i].status === 0) {
								this.data[j].noget = "error";
							} else {
								this.data[j].noget = "right";
							}
						}
					}
				}
			},
			// 搜索小区
			async searchChangeS() {
				await this.getcommunityLists(this.company_id);

				for (var i = 0; i < this.searchCityForm.length; i++) {
					for (var j = 0; j < this.data.length; j++) {
						if (this.searchCityForm[i].xiaoqu_id == this.data[j].id) {
							this.data[j].ifget = "right";
							if (this.searchCityForm[i].status === 0) {
								this.data[j].noget = "error";
							} else {
								this.data[j].noget = "right";
							}
						}
					}
				}
			},
			//请求
			async initList() {
				let fn = getpersonList;
				this.tableListLoading = true;
				this.tableSelected = [];
				await fn(this.searchForm)
					.then((res) => {
						this.tableList = res.data.records;
						console.log(this.tableList)
						this.tableLists = this.tableList.filter((res) => {
							return res.type == "2" || res.type == "4";
						});
						this.total = res.data.total;
					})
					.catch((err) => {
						this.$message.error("请求出错,请重试或联系管理员！");
					});
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-tree-node {
		float: left;
	}

	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	/deep/ .el-checkbox {
		width: 15px;
	}

	.custom-size {
		zoom: 220%;
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}

	/deep/ .el-tree-node__content {
		height: 45px;
	}

	/deep/ .el-checkbox__input {
		margin-top: 0.65vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/identity/manager.vue